import React from 'react'
import { Helmet } from 'react-helmet-async'

function Metadata() {
  if (!window.metadata) return null

  const { title, description } = window.metadata

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name='description' content={description} />}
    </Helmet>
  )
}

export default Metadata
